import type { ElearningTheme } from "./elearning.theme";

export const legacyTheme: ElearningTheme = {
  name: "hoges",
  base: "16px",
  grid: 5,
  // colors -----------
  palette: {
    background: "#FFFFFF",
    feedback: {
      // green
      success: {
        brand: "#5BDD87",
        _200: "#EDFFF3",
      },
      // red
      error: {
        brand: "#CA0000",
        _200: "#FFEBEB",
      },
      // yellow
      inProgress: {
        brand: "#FFD54F",
        _200: "#FFF7D8",
      },
    },
    // pink
    primary: {
      brand: "#E00B7E",
      _900: "#B70063",
      _200: "#FFE9F5",
    },
    // blue
    secondary: {
      brand: "#1285C7",
      _900: "#0083C9",
      _200: "#F0F8FF",
    },
    // gray
    neutral: {
      black: "#1E1F3C",
      _900: "#757575",
      _700: "#A1A2A3",
      _600: "#ACACAC",
      _400: "#DADADA",
      _200: "#F2F2F2",
      _100: "#F9F9F9",
      _80: "#4E6089",
      _10: "#EDF2FD",
      _40: "#EDF2FD",
      _60: "#8191B5",
      _20: "#CEDBF8",
      _00: "#292A54",
      white: "#FFFFFF",
    },
    accent: {
      _01: "#FCF9F4",
      _02: "#FFA4A2",
      _03: "#EE98FB",
      _04: "#399D92",
      _05: "#F0B500",
      _06: "#FFF7D8",
      _07: "#EEF7FF",
    },
  },

  // Typography -----------

  font: {
    family: {
      text: {
        extraBold: "InterExtraBold, Helvetica, Arial, sans-serif",
        bold: "InterBold, Helvetica, Arial, sans-serif",
        medium: "InterMedium, Helvetica, Arial, sans-serif",
        regular: "InterRegular, Helvetica, Arial, sans-serif",
        light: "InterLight, Helvetica, Arial, sans-serif",
      },
    },
    weight: {
      light: 300,
      normal: 400,
      bold: 500,
      bolder: 900,
    },
    size: {
      _12: "0.75rem", // 12px,
      _14: "0.875rem", // 14px,
      _16: "1rem", // 16px base
      _18: "1.125rem", // 18px
      _24: "1.5rem", // 24px
      _32: "2rem", // 32px
      _48: "3rem", // 48px
      _64: "4rem", // 64px
    },
    iconSize: {
      _5: "0.3125rem", // 5px,
      _10: "0.625rem", // 10px,
      _15: "0.9375rem", // 15px,
      _20: "1.25rem", // 20px
      _30: "1.875rem", // 30px
      _40: "2.5rem", // 40px
      _50: "3.125rem", // 50px
      _60: "3.75rem", // 60px
    },
  },

  // Responsive -----------
  breakpoints: {
    mobile: "425px",
    tablet: "768px",
    laptop: "1024px",
    laptopL: "1440px",
  },

  // Border radius -----------
  borderRadius: {
    rounded: ".25rem",
    roundedPill: "50rem",
  },

  pageLayout: {
    bottomRowHeight: "200px",
    topRowHeight: "5rem",
    numberOfColumns: 12,
    columnWidth: "1fr",
  },
};
